module.exports = __webpack_public_path__ + "img/materials-box.2ac3fd26.webp";